import { createTreeInsertionController } from './InsertionSharedCode';

// Export AVL controller (isAVLp = 'splay')
export default createTreeInsertionController('splay');
